// extracted by mini-css-extract-plugin
export default {"selected-items-extras":"ngREU","selectedItemsExtras":"ngREU"};